import React, { useState, useEffect } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import MiscPageLayout from "../../components/FullPageLayout/MiscPageLayout";
import { connect } from "react-redux";
import { fetchSupportInfo } from "../../redux/actions/supportActions";

function SyncAccount(props) {
  const { supportInfo } = props;
  const [companyVisionUrl, setCompanyVisionUrl] = useState("");
  const handleContinueSyncClick = () => {
    //TODO: add implementation to continue syncing account with the provided company url here
  };

  const handleUrlChange = event => {
    setCompanyVisionUrl(event.target.value);
  };

  useEffect(() => {
    if (!supportInfo) {
      props.fetchSupportInfo();
    }
  }, []);

  const children = (
    <Box display="flex" flexDirection="column" mx={{ xs: 2, md: 0 }}>
      <Box mt={8}>
        <Box>
          <Typography variant="h4" color="textSecondary">
            Please enter your company’s Grace Hill Vision URL to continue.
          </Typography>
        </Box>
        <Box mt={3}>
          <Typography variant="body2" color="textSecondary">
            {`Need help syncing your Visto user account? Call us at ${supportInfo.phoneNumber}
             ${supportInfo.operationHours}`}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={8} flexDirection={{ xs: "column", sm: "row" }}>
        <Box
          display="flex"
          alignItems="center"
          mr={{ xs: 0, sm: 2 }}
          mb={{ xs: 2, sm: 0 }}
        >
          <Typography variant="subtitle1" color="textSecondary">
            www.gracehillvision.com/
          </Typography>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent={{ xs: "flex-end", sm: "flex-start" }}
          maxWidth={430}
          flex={1}
        >
          <TextField
            fullWidth
            value={companyVisionUrl}
            onChange={handleUrlChange}
            margin="normal"
            variant="filled"
            onKeyPress={ev => {
              if (ev.key === "Enter") {
                handleContinueSyncClick();
              }
            }}
            placeholder="gh_content"
            hiddenLabel
          />
        </Box>
      </Box>
      <Box my={8}>
        <Button
          variant="contained"
          color="primary"
          className="wide"
          onClick={handleContinueSyncClick}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );

  return (
    <MiscPageLayout
      title={
        <Typography variant="h1">Welcome to Grace Hill’s Vision</Typography>
      }
      children={children}
    ></MiscPageLayout>
  );
}

const mapDispatchToProps = {
  fetchSupportInfo
};

const mapStateToProps = state => ({
  supportInfo: state.supportState.supportInfo.graceHillSupport
});

export default connect(mapStateToProps, mapDispatchToProps)(SyncAccount);
